var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentDocument
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "lightcase-holder",
            style: (_vm.isVideo ? "padding:0; " : "") + "display: none;",
            attrs: { id: _vm.name }
          },
          [
            _vm.currentDocument.no_document
              ? _c("span", { staticClass: "reason-holder" }, [
                  _vm._v(_vm._s(_vm.currentDocument.reason))
                ])
              : _vm.isVideo
              ? _c("div", { staticClass: "js-video video-wrap" }, [
                  _c(
                    "video",
                    { attrs: { width: "320", height: "240", controls: "" } },
                    [
                      _c("source", {
                        attrs: {
                          src: _vm.currentDocument.url,
                          type: "video/mp4"
                        }
                      }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          src: _vm.currentDocument.alternate_url,
                          type: "video/webm"
                        }
                      }),
                      _vm._v(
                        "\n        Your browser does not support the video tag.\n      "
                      )
                    ]
                  )
                ])
              : _c("div", { staticClass: "image-holder" }, [
                  _c(
                    "div",
                    { staticClass: "js-lightcase-image image-holder__block" },
                    [
                      _c("img", {
                        attrs: { src: "", "data-src": _vm.imageSrc }
                      })
                    ]
                  )
                ]),
            _vm._v(" "),
            !_vm.disableRotate && !_vm.currentDocument.no_document
              ? _c(
                  "div",
                  {
                    staticClass: "rotate-button",
                    style: _vm.rotateButtonStyles
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", { staticClass: "btn" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "js-confirm-rotate-save",
                          attrs: { href: "#" }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v("\n        /\n        "),
                      _c(
                        "a",
                        { attrs: { href: _vm.downloadLink, download: "" } },
                        [_vm._v("Download")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "image-facilities" }, [
              _vm.showComputedDetails
                ? _c("span", [
                    _c(
                      "span",
                      { staticStyle: { "text-transform": "capitalize" } },
                      [_vm._v(_vm._s(this.details ? this.details.name : ""))]
                    ),
                    _vm._v(
                      "\n        " + _vm._s(_vm.computedDetails) + "\n        "
                    ),
                    _c("sup", [_vm._v("2")])
                  ])
                : _c(
                    "span",
                    { staticStyle: { "text-transform": "capitalize" } },
                    [_vm._v(_vm._s(this.details ? this.details.name : ""))]
                  )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "rotate-left",
        staticStyle: { "font-size": "18px", padding: "3px 0" },
        attrs: { href: "#" }
      },
      [_c("i", { staticClass: "fa fa-undo", attrs: { "aria-hidden": "true" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "zoom-tools" }, [
      _c("i", [_vm._v("Zoom")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            id: "zoomInIcon",
            href: "javascript:void(0);",
            title: "Zoom in"
          }
        },
        [_vm._v("+")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "disabled",
          attrs: {
            id: "zoomOutIcon",
            href: "javascript:void(0);",
            title: "Zoom out"
          }
        },
        [_vm._v("-")]
      ),
      _vm._v(" "),
      _c("a", { attrs: { id: "resetZoom", href: "javascript:void(0);" } }, [
        _vm._v("Original size")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "rotate",
        staticStyle: { "font-size": "18px", padding: "3px 0" },
        attrs: { href: "#" }
      },
      [
        _c("i", {
          staticClass: "fa fa-repeat",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5271ed32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5271ed32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VLightcaseHolder.vue
// module id = 307
// module chunks = 1 2